import React, { useEffect } from 'react';

import { AxiosInstance } from 'axios';
import { sortBy, toPairs } from 'lodash';

import { CustomAccessType } from '/types';
import { Trans } from '/utils/translations';

type AccessJson = {
  key: {
    name: string;
    organizationName: string;
    email: string;
  };
};

const transformAccess = (data: {
  organizations: AccessJson;
  usergroups: AccessJson;
  users: AccessJson;
}): CustomAccessType[] => {
  const customAccessLists = [];
  const { organizations, usergroups, users } = data;

  if (organizations && Object.keys(organizations).length) {
    customAccessLists.push({
      key: 'organizations',
      title: <Trans>Organisation Access</Trans>,
      accessItems: sortBy(toPairs(organizations), (x) => x[1].name).map(
        ([key, x]) => ({
          key,
          name: x.name,
          company: '',
        }),
      ),
    });
  }

  if (usergroups && Object.keys(usergroups).length) {
    customAccessLists.push({
      key: 'usergroups',
      title: <Trans>Group Access</Trans>,
      accessItems: sortBy(toPairs(usergroups), (x) => x[1].name).map(
        ([key, x]) => ({
          key,
          name: x.name,
          company: x.organizationName,
        }),
      ),
    });
  }

  if (users && Object.keys(users).length) {
    customAccessLists.push({
      key: 'users',
      title: <Trans>User Access</Trans>,
      accessItems: sortBy(toPairs(users), (x) => x[1].email).map(
        ([key, x]) => ({
          key,
          name: `${x.name} (${x.email})`,
          company: x.organizationName,
        }),
      ),
    });
  }

  return customAccessLists;
};

const useFetchCustomAccess = (
  cwaAxios: AxiosInstance,
  articleAccessUrl: string,
  setAccess: (access: CustomAccessType[]) => void,
): void => {
  useEffect(() => {
    cwaAxios.get(articleAccessUrl).then((resp) => {
      setAccess(transformAccess(resp.data));
    });
  }, [cwaAxios, articleAccessUrl, setAccess]);
};

export default useFetchCustomAccess;
